module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-13.3ed955a9.jpg";